"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectOnChange = exports.redirectOnSuccess = exports.updateUserState = exports.formHandleSubmit = void 0;
var constants_1 = require("Utils/redux/actions/constants");
var creds_1 = __importDefault(require("Utils/data/creds"));
exports.formHandleSubmit = function (evee, currentUser) { return __awaiter(void 0, void 0, void 0, function () {
    var admin, client, buyer, user, shouldRedirect;
    return __generator(this, function (_a) {
        evee.preventDefault();
        admin = creds_1.default.admin, client = creds_1.default.client, buyer = creds_1.default.buyer;
        shouldRedirect = true;
        try {
            switch (currentUser) {
                case "admin":
                    user = admin;
                    break;
                case "client":
                    user = client;
                    break;
                case "buyer":
                    user = buyer;
                    break;
                default:
                    shouldRedirect = false;
            }
        }
        catch (err) {
            console.log(err);
        }
        return [2, Object.assign(user, { shouldRedirect: shouldRedirect })];
    });
}); };
exports.updateUserState = function (returnValue, dispatch) {
    dispatch({
        type: constants_1.SET_CURRENT_USERID,
        payload: returnValue.userId
    });
    dispatch({
        type: constants_1.SET_CURRENT_CLIENTID,
        payload: returnValue.clientId
    });
    dispatch({
        type: constants_1.SET_CURRENT_ADDRESS,
        payload: returnValue.address
    });
    dispatch({
        type: constants_1.SET_CURRENT_STATE,
        payload: returnValue.state
    });
    return returnValue;
};
exports.redirectOnSuccess = function (gate, history) {
    if (gate.shouldRedirect) {
        if (gate.user === "buyer") {
            history.push("/Signature");
        }
        else if (gate.user === "admin") {
            history.push("/SignUp");
        }
        else if (gate.user === "client") {
            history.push("/Dashboard");
        }
    }
};
exports.selectOnChange = function (evee, dispatch) {
    var currentUser = evee.target.value;
    var admin = creds_1.default.admin, client = creds_1.default.client, buyer = creds_1.default.buyer;
    var emailPayload;
    var passwordPayload;
    var shouldDispatch;
    switch (currentUser) {
        case "admin":
            emailPayload = admin.email;
            passwordPayload = admin.password;
            shouldDispatch = true;
            break;
        case "client":
            emailPayload = client.email;
            passwordPayload = client.password;
            shouldDispatch = true;
            break;
        case "buyer":
            emailPayload = buyer.email;
            passwordPayload = buyer.password;
            shouldDispatch = true;
            break;
        default:
            shouldDispatch = false;
            break;
    }
    if (shouldDispatch) {
        dispatch({
            type: constants_1.SET_CURRENT_USER,
            payload: currentUser
        });
        dispatch({
            type: constants_1.SET_CURRENT_EMAIL,
            payload: emailPayload
        });
        dispatch({
            type: constants_1.SET_CURRENT_PASSWORD,
            payload: passwordPayload
        });
    }
};
//# sourceMappingURL=data:application/json;base64,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